// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2X2X9","item":"PaymentsMobile_item__2Q4wE","label":"PaymentsMobile_label__3Xo_3","amount":"PaymentsMobile_amount__3iAls"};